<template>
  <div>
    <h1>Sitemap</h1>

    <template v-if="isTeemillPaymentProcessor">
      <div class="mb-12">
        <h3>Contacts</h3>

        <p class="pb-4">
          <b>
            {{ $store.state.subdomain.company.name }} website content is
            independently owned and operated by &copy;{{
              $store.state.subdomain.company.name
            }}
          </b>
        </p>

        <div v-for="{title, links} in contactSection" :key="title" class="pb-4">
          <h5>{{ title }}</h5>
          <div v-for="{text, href} in links" :key="text">
            <tml-anchor :text="text" :href="href" />
          </div>
        </div>
        <hr class="my-4" />
      </div>
    </template>
    <tml-loader :loading="!loadedRoutes" height="30em">
      <div v-for="(group, index) in routes" :key="group.name" class="mb-12">
        <h3>{{ group.name }}</h3>
        <div
          :class="
            group.routes.length > 10
              ? 'grid grid-cols-2 md:grid-cols-3 gap-2'
              : ''
          "
        >
          <div
            v-for="route in group.routes"
            :key="route.url"
            :class="group.routes.length > 10 ? '' : 'mb-2'"
          >
            <tml-anchor :text="route.title" :href="route.url" />
          </div>
        </div>
        <hr v-if="index < routes.length - 1" class="my-4" />
      </div>
    </tml-loader>
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import {formatUrl} from '@teemill/common/helpers';
import {usePaymentProcessorStore} from '@teemill/common/vuex';
import {computed} from 'vue';
import {useHead} from '@vueuse/head';

export default {
  name: 'SitemapPage',

  data() {
    return {
      loadedRoutes: false,
      routes: [],

      groups: {
        '/product/': {
          name: 'Products',
          order: 5,
        },
        '/blog/': {
          name: 'Blog posts',
          order: 3,
        },
        '/collection/': {
          name: 'Collections',
          order: 2,
        },
        '/terms/': {
          name: 'Terms',
          order: 4,
        },
        '/': {
          name: 'Pages',
          order: 1,
        },
      },

      exclusions: ['/404/'],

      contactSection: [
        {
          title: 'Customer support',
          show: true,
          links: [
            {
              text: 'Where is my order',
              href: '/help/',
            },
            {
              text: 'Returns & exchanges',
              href: '/help/',
            },
            {
              text: 'Get in touch',
              href: '/help/',
            },
          ],
        },
        {
          title:
            'Webhosting and fulfilment service hosted by Teemill Tech Ltd.',
          links: [
            {
              text: 'Website terms of use',
              href: '/terms-of-use/',
            },
            {
              text: 'Checkout and terms of sale',
              href: '/terms-of-sale/',
            },
            {
              text: 'Privacy Policy',
              href: '/privacy-policy/',
            },
          ],
        },
        {
          title: 'Issue with content hosted on this store?',
          links: [
            {
              text: 'IP / TM infringement report',
              href: '/help/reason/report/',
            },
          ],
        },
      ],
    };
  },

  computed: {
    isTeemillPaymentProcessor() {
      return (
        usePaymentProcessorStore().getter('paymentProcessorType') === 'teemill'
      );
    },
  },

  created() {
    useHead(
      computed(() => ({
        title: $store.state.title,
      }))
    );

    this.axios.get(formatUrl('/omnis/v3/sitemap/')).then(({data}) => {
      this.routes = Object.keys(data)
        .map(groupUrl => ({
          name: this.groups[groupUrl]?.name || groupUrl,
          order: this.groups[groupUrl]?.order || Infinity,
          routes: uniqBy(data[groupUrl], route => route.title).filter(
            route => !this.exclusions.includes(route.url)
          ),
        }))
        .filter(group => group.routes.length > 0)
        .sort((a, b) => a.order - b.order);

      this.loadedRoutes = true;
    });
  },
};
</script>
